let currentStep = 1;
const totalSteps = 4;
let storesData = null;
let selectedShoppingMethod = null;
let selectedStore = null;

// Track which shopping method option is selected
let selectedShoppingOption = null;

// Fetch stores data on page load
function fetchStoresData() {
  $.ajax({
    url: document.querySelector('[data-stores-url]').getAttribute('data-stores-url'),
    type: 'GET',
    dataType: 'json',
    success: function(data) {
      storesData = data;
    },
    error: function(error) {
      console.error('Error loading stores data:', error);
    }
  });
}

// Initialize shopping method option click handlers
function initShoppingMethodOptions() {
  $('.shopping-method-option').on('click', function() {
    selectedShoppingOption = $(this);
    const method = $(this).attr('data-method');
    
    // Remove previous selection styling
    $('.shopping-method-option').css({
      borderColor: '#ddd',
      backgroundColor: '#f9f9f9'
    });
    
    // Add styling to selected option
    $(this).css({
      borderColor: '#c41230',
      backgroundColor: '#fff5f5'
    });
    
    // Update images based on selection
    if (method === 'inHome') {
      $('#inHomeImg').attr('src', document.querySelector('[data-inhome-img]').getAttribute('data-inhome-img'));
      $('#inStoreImg').attr('src', document.querySelector('[data-instore-off-img]').getAttribute('data-instore-off-img'));
    } else if (method === 'inStore') {
      $('#inStoreImg').attr('src', document.querySelector('[data-instore-on-img]').getAttribute('data-instore-on-img'));
      $('#inHomeImg').attr('src', document.querySelector('[data-inhome-off-img]').getAttribute('data-inhome-off-img'));
    }
  });
}

// Day names for time slot calculation
const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function getDayFromDate(d) {
  return weekday[d.getDay()];
}

function computeStartAndEndTime(d) {
  const dayOfWeek = getDayFromDate(d);
  let startTime = 8;
  let endTime = 19;
  if (dayOfWeek === "Saturday") {
    startTime = 8;
    endTime = 18;
  } else if (dayOfWeek === "Sunday") {
    startTime = 9;
    endTime = 17;
  }
  return [startTime, endTime];
}

// Helper function to populate time slot options
function populateTimeSlots(startHour, endHour, skipArray, dateValue, isToday, currentHour) {
  const timeSlot = document.getElementById('appointmentTime');
  
  for (let i = startHour; i <= endHour; i++) {
    let timeLabel;
    if (i < 12) {
      timeLabel = i + ':00 AM';
    } else if (i === 12) {
      timeLabel = '12:00 PM';
    } else {
      timeLabel = (i - 12) + ':00 PM';
    }

    // Skip booked slots or past times
    if (skipArray && skipArray.indexOf(timeLabel) !== -1) {
      continue;
    }

    // If it's today, only show times after current hour + 4 hour buffer
    if (isToday && i <= currentHour + 4) {
      continue;
    }

    const option = document.createElement('option');
    option.value = timeLabel;
    option.textContent = timeLabel;
    timeSlot.appendChild(option);
  }
}

// Fetch and populate time slots for selected date
function setMinDateAndTimeSlot(selectedDate) {
  const dateObj = new Date();
  let newDate;
  let dayOfWeek;
  let startTime;
  let endTime;
  let dateStr = '';
  let dateValue = null;

  if (selectedDate) {
    // Parse date string in local timezone to avoid UTC conversion
    const [year, month, day] = selectedDate.split('-');
    dateValue = new Date(year, month - 1, day); // month is 0-indexed
    newDate = dateValue.getDate();
    dateStr = ('0' + (dateValue.getMonth() + 1)).slice(-2) + '/' + ('0' + dateValue.getDate()).slice(-2) + '/' + dateValue.getFullYear();
    dayOfWeek = getDayFromDate(dateValue);

    const computedTime = computeStartAndEndTime(dateValue);
    startTime = computedTime[0];
    endTime = computedTime[1];
  }

  const timeSlot = document.getElementById('appointmentTime');
  timeSlot.innerHTML = '<option value="">Select a time</option>';

  // For in-store shopping, validate that a store has been selected first
  if (selectedShoppingMethod === 'inStore' && !selectedStore) {
    showError('storeLocationsList', 'Please select a store first');
    showError('appointmentDate', 'Please select a store first');
    showError('appointmentTime', 'Please select a store first');
    return;
  }

  // Check if selected date is today
  const today = new Date();
  const isToday = dateValue && 
                  dateValue.getFullYear() === today.getFullYear() &&
                  dateValue.getMonth() === today.getMonth() &&
                  dateValue.getDate() === today.getDate();
  const currentHour = today.getHours();

  // For in-store shopping, use store hours directly
  if (selectedShoppingMethod === 'inStore' && selectedStore && selectedStore.hours) {
    const dayName = dayOfWeek.toLowerCase();
    const hoursString = selectedStore.hours[dayName];

    if (hoursString && hoursString.toLowerCase() !== 'closed') {
      // Parse hours string (e.g., "7:00AM to 4:00PM")
      const parts = hoursString.split(' to ');
      if (parts.length === 2) {
        const openTime = parseTime(parts[0].trim());
        const closeTime = parseTime(parts[1].trim());

        if (openTime !== null && closeTime !== null) {
          const openHour = Math.floor(openTime / 60);
          const closeHour = Math.floor(closeTime / 60);

          // Use the helper function to populate slots
          populateTimeSlots(openHour, closeHour, null, dateValue, isToday, currentHour);
        }
      }
    }
    return;
  }

  // For in-home shopping, fetch available time slots from API
  if (selectedStore && selectedStore.name && dateStr) {
    $.ajax({
      url: serviceUrl + "/validate-hours?locationName="+selectedStore.name+"&apptDate="+dateStr,
      type: 'POST',
      contentType: 'application/json',
      success: function(data) {
        const timeSlot = document.getElementById('appointmentTime');
        timeSlot.innerHTML = '<option value="">Select a time</option>';

        const maxAppointments = dayOfWeek === "Sunday" ? selectedStore.max_appointments_sunday : selectedStore.max_appointments_other;
        const skipArray = [];

        // Collect booked time slots
        if (data.booked) {
          for (const key in data.booked) {
            if (data.booked.hasOwnProperty(key)) {
              if (data.booked[key] >= maxAppointments) {
                skipArray.push(key);
              }
            }
          }
        }

        // Use the helper function to populate slots
        populateTimeSlots(startTime, endTime, skipArray, dateValue, isToday, currentHour);
      },
      error: function(error) {
        console.error('Error fetching time slots:', error);
      }
    });
  }
}

// Search for in-home shopping stores by zip code
function searchInHomeStoresByZipCode(zipCode) {
  if (!storesData) {
    console.warn('Stores data not loaded yet');
    return [];
  }

  // Find in-home shopping stores that serve this zip code (check service_area_zips)
  const inHomeShoppingStores = storesData.locations.filter(store => {
    const isInHomeShopping = (store.location_type === 'In-Home Shopping' ||
                              store.services.includes('In-Home Shopping') ||
                              (store.services_offered && store.services_offered.includes('In-Home Shopping')));

    // Check if this zip code is in their service area
    const servesThisZip = store.service_area_zips &&
                         Array.isArray(store.service_area_zips) &&
                         store.service_area_zips.includes(zipCode);

    return isInHomeShopping && servesThisZip;
  });


  return { inHome: inHomeShoppingStores };
}

// Check store availability for a given zip code
function checkStoreAvailability(zipCode, callback) {
  // Check for in-home stores
  const inHomeStores = searchInHomeStoresByZipCode(zipCode);
  const hasInHomeStores = inHomeStores.inHome && inHomeStores.inHome.length > 0;
  
  // Check for in-store locations via geocoding
  geocodeZipCode(zipCode, function(geocodedLocation) {
    let hasInStoreStores = false;
    
    if (geocodedLocation) {
      const nearestStores = getNearestStoresByRadius(geocodedLocation, 50);
      hasInStoreStores = nearestStores && nearestStores.length > 0;
    }
    
    callback({
      hasInHome: hasInHomeStores,
      hasInStore: hasInStoreStores,
      inHomeStores: inHomeStores.inHome || [],
      zipCode: zipCode
    });
  });
}

// Show shopping preference options based on available services
function showShoppingOptions(zipCode) {
  // Check store availability
  checkStoreAvailability(zipCode, function(availability) {
    if (!availability.hasInHome && !availability.hasInStore) {
      // No stores available - show error message
      showNoStoresAvailableError();
      return;
    }
    
    // Show only available shopping options
    if (availability.hasInHome) {
      $('#inHomeOption').show();
    } else {
      $('#inHomeOption').hide();
    }
    
    if (availability.hasInStore) {
      $('#inStoreOption').show();
    } else {
      $('#inStoreOption').hide();
    }

    const $container = $('#shoppingOptionsContainer');
    // Adjust grid columns based on number of available options
    const visibleOptions = (availability.hasInHome ? 1 : 0) + (availability.hasInStore ? 1 : 0);
    if (visibleOptions === 1) {
      $container.css('grid-template-columns', '1fr');
    } else {
      $container.css('grid-template-columns', '1fr 1fr');
    }
    
    // Hide zip code section and show shopping preference section
    $('#zipCodeSection').hide();
    $('#shoppingPreferenceSection').show();
  });
  
  return true;
}

// Show no stores available error message
function showNoStoresAvailableError() {
  // Hide zip code section
  $('#zipCodeSection').hide();
  
  // Create error message section
  let $errorSection = $('#noStoresAvailableSection');
  if ($errorSection.length === 0) {
    $errorSection = $(`
      <div id="noStoresAvailableSection" style="margin: 40px auto; max-width: 800px; text-align: center;">
        <div style="background-color: #ffebee; border: 2px solid #d32f2f; border-radius: 4px; padding: 40px 24px; text-align: center;">
          <i class="fas fa-map-marker-alt" style="font-size: 40px; color: #d32f2f; margin-bottom: 16px; display: block;"></i>
          <h3 style="color: #d32f2f; font-size: 24px; font-weight: 700; margin: 0 0 12px 0;">No Stores Available</h3>
          <p style="color: #333; font-size: 16px; line-height: 1.6; margin: 0 0 24px 0;">Unfortunately, we don't have any service options available for this zip code. Please try a different location or contact us for more information.</p>
        </div>
        <div class="formButtons" style="margin-top: 24px;">
          <button type="button" class="btn btn-prev" onclick="handleZipCodePrevious(event); return false;" style="display: inline-flex; gap: 8px; align-items: center;">
            <i class="fal fa-arrow-left"></i> Try Another Zip Code
          </button>
        </div>
      </div>
    `);
    
    // Insert after shopping preference section
    $('#shoppingPreferenceSection').after($errorSection);
  }
  
  // Show error section
  $('#noStoresAvailableSection').show();
  $('#shoppingPreferenceSection').hide();
}

// Handle zip code submission
function handleZipCodeSubmit(e) {
  if (e) e.preventDefault();

  const zipCode = $('#zipCode').val().trim();
  if (!zipCode) {
    showError('zipCode', 'Please enter your zip code');
    return false;
  }

  // Validate zip code format (5 digits)
  const zipRegex = /^\d{5}$/;
  if (!zipRegex.test(zipCode)) {
    showError('zipCode', 'Please enter a valid 5-digit zip code');
    return false;
  }

  clearError('zipCode');
  
  // Hide error section if it exists
  $('#noStoresAvailableSection').hide();
  
  // Reset shopping options visibility
  selectedShoppingOption = null;

  // Show shopping options based on available services
  showShoppingOptions(zipCode);

  return true;
}

function handleZipCodePrevious(e) {
  if (e) e.preventDefault();

  clearError('zipCode');
  
  // Reset shopping option selection
  selectedShoppingOption = null;
  
  // Reset all shopping options styling
  $('.shopping-method-option').css({
    borderColor: '#ddd',
    backgroundColor: '#f9f9f9'
  });
  
  // Reset images to off state
  $('#inHomeImg').attr('src', document.querySelector('[data-inhome-off-img]').getAttribute('data-inhome-off-img'));
  $('#inStoreImg').attr('src', document.querySelector('[data-instore-off-img]').getAttribute('data-instore-off-img'));

  $('#zipCodeSection').show();
  $('#shoppingPreferenceSection').hide();
  $('#noStoresAvailableSection').hide();

  return true;
}

 // Select shopping method
 function selectShoppingMethod(method, element) {
   selectedShoppingMethod = method;

   // Get the store based on selected method
   const zipCode = document.getElementById('zipCode').value.trim();
   const stores = searchInHomeStoresByZipCode(zipCode);

   if (method === 'inHome' && stores.inHome.length > 0) {
     selectedStore = stores.inHome[0];
   } else if (method === 'inStore') {
     // For in-store, get coordinates from zipCode using geocoding and find nearest stores
     const zipCode = document.getElementById('zipCode').value.trim();
     
     geocodeZipCode(zipCode, function(geocodedLocation) {
       if (geocodedLocation) {
         // Add name property for logging in getNearestStoresByRadius
         geocodedLocation.name = 'Search Location';

         // Get nearest stores based on geocoded coordinates
         populateNearestStores(geocodedLocation);
       } else {
         console.error('Could not geocode zip code');
       }
     });
   }

    // Remove previous selection styling
    $('#inHomeOption > div, #inStoreOption > div').css({
      borderColor: '#ddd',
      backgroundColor: '#f9f9f9'
    });

    // Add styling to selected option
    $(element).css({
      borderColor: '#c41230',
      backgroundColor: '#fff5f5'
    });

    // Update image based on selection
    if (method === 'inHome') {
      $('#inHomeImg').attr('src', document.querySelector('[data-inhome-img]').getAttribute('data-inhome-img'));
      $('#inStoreImg').attr('src', document.querySelector('[data-instore-off-img]').getAttribute('data-instore-off-img'));
      // Show address fields for in-home
      $('#addressFieldsContainer').show();
      // Add required attribute to address fields
      $('#streetAddress, #city, #state, #zipCodeStep3').prop('required', true);
      // Hide store selection for in-home
      $('#storeSelectionSection').hide();
    } else if (method === 'inStore') {
      $('#inStoreImg').attr('src', document.querySelector('[data-instore-on-img]').getAttribute('data-instore-on-img'));
      $('#inHomeImg').attr('src', document.querySelector('[data-inhome-off-img]').getAttribute('data-inhome-off-img'));
      // Hide address fields for in-store
      $('#addressFieldsContainer').hide();
      // Remove required attribute from address fields when hidden
      $('#streetAddress, #city, #state, #zipCodeStep3').prop('required', false);
      // Show store selection for in-store
      $('#storeSelectionSection').show();
    }

  }

 function selectRetailStore(store) {
   selectedStore = store;
 }

 function deg2rad(deg) {
   return deg * (Math.PI / 180);
 }

  function getNextOpeningDay(hours, currentDay, openTimeInMinutes, currentTimeInMinutes, closeTimeInMinutes) {
    const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    
    for (let i = 1; i < days.length; i++) {
      let nextDay = days[(days.indexOf(currentDay.toLowerCase()) + i) % days.length];
      let nextDayHours = hours[nextDay];
      if(openTimeInMinutes >= currentTimeInMinutes && currentTimeInMinutes < closeTimeInMinutes){
        nextDay = currentDay
      }
      if (nextDayHours && nextDayHours.toLowerCase() !== 'closed') {
        return nextDay.charAt(0).toUpperCase() + nextDay.slice(1); 
      }
    }
    return "Monday"; // Default if no opening found
  }

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 3959; // Radius of the earth in miles
    var dLat = deg2rad(lat2 - lat1);
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var miles = R * c;
    return miles.toFixed(1) * 1;
  }

  // Parse time string (e.g., "9:00AM") to minutes since midnight
  function parseTime(timeStr) {
    var match = timeStr.match(/(\d{1,2}):(\d{2})(AM|PM)/);
    if (!match) return null;
    var hour = parseInt(match[1]);
    var min = parseInt(match[2]);
    var period = match[3];
    if (period === 'PM' && hour !== 12) hour += 12;
    if (period === 'AM' && hour === 12) hour = 0;
    return hour * 60 + min;
  }

  // Format minutes since midnight to time string (e.g., "9:00 AM")
  function formatTime(hour, min, period) {
    return (hour % 12 || 12) + ':' + (min < 10 ? '0' : '') + min + ' ' + period;
  }


  // Filter duplicates helper function
  function filterDuplicates(data) {
    var obj = {};
    for (var i = 0; i < data.length; i++) {
      obj[data[i].name] = data[i]; // Use name as unique identifier
    }
    
    data = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        data.push(obj[key]);
      }
    }
    return data;
  }

  // Geocode zip code to get coordinates
  function geocodeZipCode(zipCode, callback) {
    const geo = new google.maps.Geocoder();
    geo.geocode({ 'address': zipCode }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        callback({ latitude: lat, longitude: lng, zip: zipCode });
      } else {
        console.error('Geocoder failed due to: ' + status);
        callback(null);
      }
    });
  }

  // Get stores matching postal code + radius (50 miles default)
  function getNearestStoresByRadius(geoLocation, radiusMiles) {
    if (!storesData || !storesData.locations || !geoLocation) {
      console.warn('Stores data or geo location not available');
      return [];
    }

    radiusMiles = radiusMiles || 50; // Default to 50 miles

    // Get reference store coordinates and postal code
    var lat2 = geoLocation.latitude;
    var lon2 = geoLocation.longitude;
    var postalCode = geoLocation.zip;

    // Filter for active retail stores only (exclude the reference store itself)
    var retailStores = storesData.locations.filter(function(store) {
      return store.active &&
        (store.location_type === 'Retail' ||
         (Array.isArray(store.services_offered) && store.services_offered.includes('Retail Store'))) &&
        store.name !== geoLocation.name;
    });


    var postalcodeArr = [];
    var milesArr = [];

    // Process each retail store
    retailStores.forEach(function(store) {
      var lat1 = store.latitude;
      var lon1 = store.longitude;

      // Calculate distance using Haversine formula
      var distance = getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2);
      store.distance = distance;


      // Check if within radius
      if (Math.round(distance) <= radiusMiles) {
        milesArr.push(store);
      }

      // Check if postal code matches
      var zipCheck = store.zip;
      if (zipCheck && zipCheck !== "" && zipCheck === postalCode) {
        postalcodeArr.push(store);
      }
    });

  

    // Merge and remove duplicates
    var mergedArr = postalcodeArr.concat(milesArr);
    mergedArr = filterDuplicates(mergedArr);

    // Sort by distance (nearest first)
    mergedArr.sort(function(a, b) {
      return (a.distance || 999999) - (b.distance || 999999);
    });

    // Return only the nearest 4 stores
    mergedArr = mergedArr.slice(0, 4);

    return mergedArr;
  }

 // Populate store list with stores matching postal code + 50 mile radius
 function populateNearestStores(geoLocation) {
   // Clear any previous error messages when repopulating stores
   clearError('storeLocationsList');
   
   var nearestStores = getNearestStoresByRadius(geoLocation, 50);
   var $storesList = $('#storeLocationsList').empty();

   if (nearestStores.length === 0) {
     $storesList.html('<p style="grid-column: 1/-1; text-align: center; color: #666;">No retail stores available in your area.</p>');
     return;
   }

    nearestStores.forEach(function(store, index) {
      var checkboxId = 'store_' + index;
      var distanceText = store.distance + ' mi';

       // Get store status - Open or Closed with times
       var today = new Date();
       var dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
       var dayName = dayNames[today.getDay()];
       var todayHours = (store.hours && store.hours[dayName]) || 'Hours not available';

       var storeStatus = 'Hours not available';
      if (todayHours !== 'Hours not available' && todayHours.includes('Closed')) {
        storeStatus = 'Closed Today';
      } else if (todayHours.includes('By Appointment Only')) {
        storeStatus = todayHours;
      } else if (todayHours !== 'Hours not available') {
        var parts = todayHours.split(' to ');
        if (parts.length === 2) {
          var openMin = parseTime(parts[0].trim());
          var closeMin = parseTime(parts[1].trim());
          var currentMin = today.getHours() * 60 + today.getMinutes();

          if (openMin !== null && closeMin !== null) {
            if (currentMin >= openMin && currentMin <= closeMin) {
              // Store is open - show close time
              var closeHour = Math.floor(closeMin / 60);
              var closeMins = closeMin % 60;
              var closePeriod = closeHour >= 12 ? 'PM' : 'AM';
              var closeTimeStr = formatTime(closeHour, closeMins, closePeriod);
              storeStatus = 'Open - Closes at ' + closeTimeStr;
            } else {
              // Store is closed - find next opening
              var nextDayName = getNextOpeningDay(store.hours, dayName, openMin, currentMin, closeMin);
              var nextDayHours = (store.hours && store.hours[nextDayName.toLowerCase()]) || 'Hours not available';

              if (nextDayHours !== 'Hours not available' && !nextDayHours.toLowerCase().includes('closed')) {
                var nextParts = nextDayHours.split(' to ');
                if (nextParts.length === 2) {
                  var nextOpen = nextParts[0].trim();
                  storeStatus = 'Closed - Opens ' + nextDayName + ' at ' + nextOpen;
                } else if (nextDayHours.includes('By Appointment Only')) {
                  storeStatus = nextDayHours;
                } else {
                  storeStatus = 'Closed';
                }
              } else {
                storeStatus = 'Closed';
              }
            }
          }
        }
      }

      // hours_callout: admin-authored notice (e.g. a temporary closure) shown as
      // an alert on the card, matching the store list and store details pages.
      var calloutHtml = '';
      if (store.hours_callout) {
        calloutHtml = `
            <div class="store-hours-callout" role="alert" style="display: flex; align-items: flex-start; gap: 10px; background-color: #fff8e6; border: 1px solid #f0c674; border-left: 5px solid #d9822b; border-radius: 3px; padding: 10px 12px; margin-top: 8px; color: #4a3708; font-size: 13px; line-height: 1.5; font-style: normal; text-align: left;">
              <i class="fal fa-exclamation-circle" aria-hidden="true" style="color: #d9822b; font-size: 18px; line-height: 1.3; flex: 0 0 auto;"></i>
              <div style="flex: 1 1 auto;">
                <span class="sr-only">Important notice: </span>
                ${store.hours_callout.replace(/&nbsp;/g, ' ')}
              </div>
            </div>`;
      }

      var $storeCheckbox = $(`
        <div style="display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.3s ease; background-color: #fafafa; width: 100%; border-radius: 4px; margin-bottom: 8px; border: 2px solid #e0e0e0; padding: 12px; box-sizing: border-box;">
          <input type="checkbox" id="${checkboxId}" name="retailStore" value="${store.name || store.title}"
                 style="width: 18px; height: 18px; margin: 0 12px 0 0; cursor: pointer; accent-color: #c41230;">
          <label for="${checkboxId}" style="cursor: pointer; display: block; text-align: left; width: 100%;">
            <div style="font-size: 16px; font-weight: 700; color: #000;">${store.name || store.title}</div>
            <div style="font-size: 13px; color: #666; margin-top: 4px; line-height: 1.6;">
              ${distanceText} • ${store.address} • ${store.phone}
            </div>
            <div style="font-size: 12px; color: #999; margin-top: 4px; font-style: italic;">${storeStatus}</div>${calloutHtml}
          </label>
        </div>
      `);

      // Keep clicks inside the notice (links especially) from toggling the checkbox.
      $storeCheckbox.find('.store-hours-callout').on('click', function (e) {
        e.stopPropagation();
      });

      var $checkbox = $storeCheckbox.find('input[type="checkbox"]');
      $checkbox.on('change', function() {
        // Uncheck all other checkboxes
        $('input[name="retailStore"]').not(this).prop('checked', false);

        // Reset visual state for all store items
        $('#storeLocationsList > div').css({
          'border-color': 'transparent'
        });

        if (this.checked) {
          // Set border for selected store
          $storeCheckbox.css({
            'border': '2px solid #c41230'
          });
          selectRetailStore(store);
          // Auto-clear error message when a store is selected
          clearError('storeLocationsList');
          // Clear date and time inputs when store changes
          $('#appointmentDate').val('');
          $('#appointmentTime').val('').html('<option value="">Select a time</option>');
        } else {
          // Clear selection when unchecked
          selectedStore = null;
        }
      });

     $storesList.append($storeCheckbox);
   });
 }

 function showStep(stepNumber) {
   // Hide all steps
   for (let i = 1; i <= totalSteps; i++) {
     $(`#step${i}`).removeClass('active');
     $(`#stepDot${i}`).removeClass('active completed');
     $(`#stepLabel${i}`).css({ color: '#999', fontWeight: '500' });
   }

   // Show current step
   $(`#step${stepNumber}`).addClass('active');
   $(`#stepDot${stepNumber}`).addClass('active');
   $(`#stepLabel${stepNumber}`).css({ color: '#000', fontWeight: '600' });

   // Mark completed steps
   for (let i = 1; i < stepNumber; i++) {
     $(`#stepDot${i}`).addClass('completed');
   }

   currentStep = stepNumber;
 }

 function nextStep(e) {
   if (e) e.preventDefault();
   if (validateStep(currentStep)) {
     if (currentStep < totalSteps) {
       showStep(currentStep + 1);
       window.scrollTo({ top: 0, behavior: 'smooth' });
     }
   }
 }

 function prevStep(e) {
   if (e) e.preventDefault();
   if (currentStep > 1) {
     showStep(currentStep - 1);
     window.scrollTo({ top: 0, behavior: 'smooth' });
   }
 }

 function validateStep(stepNumber) {
   if (stepNumber === 1) {
     // Check if a shopping method option has been selected
     if (!selectedShoppingOption) {
       showError('inHomeOption', 'Please select your preferred shopping method');
       return false;
     }
     
     // Call selectShoppingMethod with the selected option
     const method = selectedShoppingOption.attr('data-method');
     selectShoppingMethod(method, selectedShoppingOption[0]);
     
     // Check if selectedShoppingMethod was set successfully
     if (!selectedShoppingMethod) {
       showError('inHomeOption', 'Please select your preferred shopping method');
       return false;
     }

     return true;
   }

   if (stepNumber === 2) {
     // Clear previous errors in step 2
     clearStepErrors(2);
     
     // For in-store shopping, validate that a store has been selected
     if (selectedShoppingMethod === 'inStore' && !selectedStore) {
       showError('storeLocationsList', 'Please select a store');
       return false;
     } else {
       clearError('storeLocationsList');
     }

     const date = $('#appointmentDate').val();
     const time = $('#appointmentTime').val();


    
    if (!date || date === '') {
      showError('appointmentDate', 'Please select a date');
      return false;
    } else {
      clearError('appointmentDate');
    }
    if (!time || time === '') {
      showError('appointmentTime', 'Please select a time');
      return false;
    } else {
      clearError('appointmentTime');
    }
    return true;
  }
  
   if (stepNumber === 3) {
     clearStepErrors(3);
     const firstName = $('#firstName').val().trim();
     const lastName = $('#lastName').val().trim();
     const email = $('#email').val().trim();
     const phone = $('#phone').val().trim();
     let hasErrors = false;

     // Validate first name
     if (!firstName) {
       showError('firstName', 'Please enter your first name');
       hasErrors = true;
     } else if (firstName.length < 2) {
       showError('firstName', 'First name must be at least 2 characters');
       hasErrors = true;
     } else {
       clearError('firstName');
     }

     // Validate last name
     if (!lastName) {
       showError('lastName', 'Please enter your last name');
       hasErrors = true;
     } else if (lastName.length < 2) {
       showError('lastName', 'Last name must be at least 2 characters');
       hasErrors = true;
     } else {
       clearError('lastName');
     }

     // Validate email format
     if (!email) {
       showError('email', 'Please enter your email address');
       hasErrors = true;
     } else {
       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
       if (!emailRegex.test(email)) {
         showError('email', 'Please enter a valid email address');
         hasErrors = true;
       } else {
         clearError('email');
       }
     }

     // Validate phone number
     if (!phone) {
       showError('phone', 'Please enter your phone number');
       hasErrors = true;
     } else {
       const phoneDigits = phone.replace(/\D/g, '');
       if (phoneDigits.length < 10) {
         showError('phone', 'Please enter a valid 10-digit phone number');
         hasErrors = true;
       } else {
         clearError('phone');
       }
     }

     // Validate at least one contact method is selected
     const contactMethodSelected = $('input[name="contactMethod"]:checked').length > 0;
     if (!contactMethodSelected) {
       const $contactCheckboxes = $('input[name="contactMethod"]').closest('div').parent();
       $contactCheckboxes.find('.errorMessage').text('Please select at least one preferred contact method').addClass('show');
       hasErrors = true;
     } else {
       $('input[name="contactMethod"]').closest('div').parent().find('.errorMessage').removeClass('show').text('');
     }

     // Only validate address fields if they are visible (inHome selection)
     if ($('#addressFieldsContainer').is(':visible')) {
       const streetAddress = $('#streetAddress').val().trim();
       const city = $('#city').val().trim();
       const state = $('#state').val();
       const zipCodeStep3 = $('#zipCodeStep3').val().trim();

       if (!streetAddress) {
         showError('streetAddress', 'Please enter your street address');
         hasErrors = true;
       } else {
         clearError('streetAddress');
       }

       if (!city) {
         showError('city', 'Please enter your city');
         hasErrors = true;
       } else {
         clearError('city');
       }

       if (!state) {
         showError('state', 'Please select your state');
         hasErrors = true;
       } else {
         clearError('state');
       }

       if (!zipCodeStep3) {
         showError('zipCodeStep3', 'Please enter your zip code');
         hasErrors = true;
       } else {
         // Validate zip code format (5 digits)
         const zipRegex = /^\d{5}$/;
         if (!zipRegex.test(zipCodeStep3)) {
           showError('zipCodeStep3', 'Please enter a valid 5-digit zip code');
           hasErrors = true;
         } else {
           clearError('zipCodeStep3');
         }
       }
     }
     return !hasErrors;
   }

   const $inputs = $(`#step${stepNumber} input[required], #step${stepNumber} select[required]`);
   for (let input of $inputs) {
    if (!input.value.trim()) {
      const $field = $(input).closest('.formField');
      if ($field.length) {
        const fieldId = input.id;
        showError(fieldId, 'Please fill in all required fields');
      }
      return false;
    }
  }
  return true;
}

 function updateSummary() {
   $('#summaryZip').text($('#zipCode').val());
   $('#summaryAppointmentDate').text($('#appointmentDate').val());
   $('#summaryAppointmentTime').text($('#appointmentTime').val());
   $('#summaryName').text($('#firstName').val() + ' ' + $('#lastName').val());
   $('#summaryEmail').text($('#email').val());
   $('#summaryPhone').text($('#phone').val());
 }

 // Display inline error message
function showError(fieldId, message) {
  // Special handling for store list error
  if (fieldId === 'storeLocationsList') {
    // Remove any existing error messages first to avoid duplicates
    $(`#${fieldId}`).siblings('.storeListError').remove();
    
    // Create new error container
    const $errorMsg = $(`<div class="storeListError" style="background-color: #ffebee; border: 1px solid #d32f2f; color: #d32f2f; padding: 12px 16px; border-radius: 4px; margin-bottom: 16px; font-size: 14px; font-weight: 500;">${message}</div>`);
    $(`#${fieldId}`).before($errorMsg);
    return;
  }
  
  const $field = $(`#${fieldId}`).closest('.formField') || $(`#${fieldId}`).parent().closest('div');
  const $errorMsg = $field.find('.errorMessage');
  
  $field.addClass('error');
  if ($errorMsg.length) {
    $errorMsg.text(message).addClass('show');
  }
}

// Clear error from field
function clearError(fieldId) {
  // Special handling for store list error
  if (fieldId === 'storeLocationsList') {
    $(`#${fieldId}`).siblings('.storeListError').remove();
    return;
  }
  
  const $field = $(`#${fieldId}`).closest('.formField') || $(`#${fieldId}`).parent().closest('div');
  $field.removeClass('error');
  $field.find('.errorMessage').removeClass('show').text('');
}

// Clear all errors in a step
function clearStepErrors(stepNumber) {
  $(`#step${stepNumber} .formField`).removeClass('error').find('.errorMessage').removeClass('show').text('');
}

// Show form submission error
function showFormError(message) {
  // Create a temporary error container at the top of the form
  const $errorContainer = $('<div style="background-color: #ffebee; border: 1px solid #d32f2f; color: #d32f2f; padding: 12px 16px; border-radius: 4px; margin-bottom: 20px; font-size: 14px; font-weight: 500;"></div>');
  $errorContainer.text(message);
  
  // Insert it at the top of the form content
  $('.formContent').prepend($errorContainer);
  
  // Auto-remove after 5 seconds
  setTimeout(() => {
    $errorContainer.fadeOut(300, function() {
      $(this).remove();
    });
  }, 5000);
}

// Handle form submission
 $('#multiStepForm').on('submit', function(e) {
   e.preventDefault();

   // Gather form data
   let flooringType = $('input[name="flooringTypes"]:checked').map(function() { return $(this).val(); }).get();
   let primaryContact = $('input[name="contactMethod"]:checked').map(function() { return $(this).val(); }).get();
   primaryContact = primaryContact.length > 0 ? primaryContact[0] : 'Email'; // Default to Email

   // Format phone number
   let phone = $('#phone').val();
   if(phone.length == 10) {
     phone = phone.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, "$1-$2-$3");
   }

   let numberOfRooms = $('#numberOfRooms').val();
  
   // Convert flooringType to array if it's a string
   if(flooringType && typeof flooringType === "string") {
     flooringType = [flooringType];
   }

   // Format date from YYYY-MM-DD to MM/DD/YYYY
   const appointmentDateRaw = $('#appointmentDate').val();
   let dateStart = '';
   if(appointmentDateRaw) {
     const dateParts = appointmentDateRaw.split('-');
     if(dateParts.length === 3) {
       dateStart = dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0]; // MM/DD/YYYY
     }
   }

   // Get favorites from localStorage
   let favUrl = '';
   let favProducts = getLocalStorage("userfav");
   if(favProducts && favProducts.length > 0) {
     for(var i in favProducts) {
       favUrl = favUrl + window.location.protocol + "//" + window.location.hostname + favProducts[i].url;
       if(i != favProducts.length - 1) {
         favUrl = favUrl + ",";
       }
     }
   }

   // Build base form data structure
   const baseFormData = {
     formType: "Scheduler",
     firstName: $('#firstName').val(),
     lastName: $('#lastName').val(),
     primaryContact: primaryContact,
     emailContact: $('#email').val(),
     phone: phone,
     numberOfRooms: numberOfRooms,
     flooringType: flooringType,
     priceRange: '',
     commentsQuestions: $('#specialNeeds').val() || '',
     favorites: favUrl
   };

   // Add location details from selected store
   if (selectedStore) {
     baseFormData.locationName = selectedStore.name || selectedStore.locationName || selectedStore.title || '';
     baseFormData.locationAddress = selectedStore.address || '';
     baseFormData.locationCity = selectedStore.city || '';
     baseFormData.locationState = selectedStore.state || '';
     baseFormData.locationZip = selectedStore.zip || '';
     baseFormData.location = selectedStore.url || selectedStore.id || '';
   } else {
     baseFormData.locationName = '';
     baseFormData.locationAddress = '';
     baseFormData.locationCity = '';
     baseFormData.locationState = '';
     baseFormData.locationZip = '';
     baseFormData.location = '';
   }

   // Build appropriate form data based on shopping method
   let formData = baseFormData;
   
   if (selectedShoppingMethod === 'inHome') {
     formData.consultationType = "InHome";
     formData.dateStart = dateStart;
     formData.timeStart = $('#appointmentTime').val();
     formData.streetAddress = $('#streetAddress').val();
     formData.streetAddress2 = $('#streetAddress2').val();
     formData.city = $('#city').val();
     formData.state = $('#state').val();
     formData.zipCode = $('#zipCodeStep3').val();
   } else if (selectedShoppingMethod === 'inStore') {
     formData.consultationType = "Showroom";
     formData.dateStart = dateStart;
     formData.timeStart = $('#appointmentTime').val();
   }
   
   window.dataLayer.push({
      'event': 'appointment_multipform_submission',
      'interaction_type': 'form_submission',
      'consultationType': formData.consultationType,
      'gtm.elementId': 'multiStepForm',
      'gtm.element': 'form',
      'gtm.elementClasses': 'multi-step-form'
    });

  
  // Get the submit button and add loader
  const $submitBtn = $('#multiStepForm').find('button[type="submit"]');
  const originalBtnContent = $submitBtn.html();
  $submitBtn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Submitting...');

  // Submit to API
  $.ajax({
    url: serviceUrl + '/forms?type=schedule',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(formData),
    success: function(response) {
      // Hide form, show success message
      $('#multiStepForm').hide();
      $('#successScreen').show();
      console.log('Form successfully submitted');
    },
    error: function(error) {
      // Re-enable button and remove loader
      $submitBtn.prop('disabled', false).html(originalBtnContent);
      showFormError('We are facing some issues with your request. Please try after sometime.');
      console.error('Error:', error);
    }
  });
 });

 // Initialize stores data on page load
 $(document).ready(function() {
   fetchStoresData();
   initShoppingMethodOptions();
  const today = new Date().toISOString().split('T')[0];
  $('#appointmentDate').attr('min', today);
 });
